import { render, staticRenderFns } from "./AlterPassword.vue?vue&type=template&id=a05b0dea&scoped=true"
import script from "./AlterPassword.vue?vue&type=script&lang=js"
export * from "./AlterPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05b0dea",
  null
  
)

export default component.exports